import Plyr from 'plyr';

export default class Player {
    constructor() {
        this.init();
    }

    init() {

        // --- PLYR ---
        const controlsPlayers = [
            'play-large',
            'play',
            'progress',
            'mute',
            'volume',
            'fullscreen'
        ];
        const players = Plyr.setup('.plyr-player', {
            controlsPlayers,
            clickToPlay: true,
            vimeo: {
                controls: 0
            },
            youtube: {
                noCookie: false,
                rel: 0,
                showinfo: 0,
                iv_load_policy: 3,
                modestbranding: 1,
                playsinline: 1
            }
        });


        const controlsPodcasts = [
            'play',
            'progress',
            'mute',
            'volume',
        ];
        const podcasts = Plyr.setup('.plyr-podcast', {
            controlsPodcasts,
            clickToPlay: true,
            vimeo: {
                controls: 0
            },
            youtube: {
                noCookie: false,
                rel: 0,
                showinfo: 0,
                iv_load_policy: 3,
                modestbranding: 1,
                playsinline: 1
            }
        });


        function launchPlyr() {
            if( players ) {
                players.forEach(function (player) {
                    player.on('play', function () {
                        var others = players.filter(other => other != player)
                        others.forEach(function (other) {
                            other.pause();
                        });
                        podcasts.forEach(function(podcast){
                            podcast.pause();
                        });
                    });
                });
            }
        }
        launchPlyr();


        function launchPodcasts() {
            if( podcasts ) {
                podcasts.forEach(function (player) {
                    player.on('play', function () {
                        var others = podcasts.filter(other => other != player)
                        others.forEach(function (other) {
                            other.pause();
                        });

                        players.forEach(function(player){
                            player.pause();
                        });
                    });
                });
            }
        }
        launchPodcasts();

    }
}